import axios from "axios";
const needsClientUrlHandling = window.location.origin !== "https://ofc-accelerate.ehs.com";

let client;
let host = window.location.origin;
axios.defaults.baseURL = '/';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

if(needsClientUrlHandling) {
    client = window.location.pathname.split("/")[1];
    host = window.location.origin + '/' + client;
    axios.defaults.baseURL = '/' + client + '/';
}

type DefaultSettingType = {
    isAdmin: boolean;
    host: string;
};

export var initialData: DefaultSettingType = {
    isAdmin: false,
    host: host
};
